import ScheduleNoSearchResultsEmptyState from './ScheduleNoSearchResultsEmptyState';

export default ScheduleNoSearchResultsEmptyState;
